import { types } from "../types/types";
const intitalState = {
    allCustomers: [],
    allFeedbacks: [],
};

const customersReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.CHANGE_CUSTOMERS:
            return {
                ...state,
                allCustomers: action.payload,
            };
        case types.CHANGE_FEEDBACKS:
            return {
                ...state,
                allFeedbacks: action.payload,
            };
        default:
            return { ...state };
    }
};

export default customersReducer;
